import React from 'react'

import { Button, ModalBase } from '@components/atoms'
import { modalCreators } from '@store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@store/hooks'

import { ModalStyles } from './styles'

const { modalDeleteAccount } = ModalStyles

export const DeleteAccount = () => {
	const dispatch = useAppDispatch()

	const {
		modal: { modalName },
	} = useAppSelector((state) => state)

	const onSubmitCreateFilter = () => {
		dispatch(modalCreators.closeModal())
	}

	return (
		<ModalBase title='Excluir conta' open={modalName === 'deleteAccount'}>
			<form onSubmit={onSubmitCreateFilter} style={{ width: '100%' }}>
				<div className={modalDeleteAccount()}>
					<p>Tem certeza que deseja apagar sua conta?</p>
					<span>ATENÇÃO!</span>
					<br />
					<br />
					<span>
						Sua conta possui uma assinatura e ao excluir você perderá o acesso.
						Para mais informações entre em contato conosco.
					</span>
				</div>
				<div style={{ display: 'flex', gap: '26px', marginTop: '34px' }}>
					<Button>Apagar</Button>
					<Button
						outlined
						onClick={() => {
							dispatch(modalCreators.closeModal())
						}}
					>
						Cancelar
					</Button>
				</div>
			</form>
		</ModalBase>
	)
}
